import { NavLink } from 'react-router-dom';
import "../CommonPage/Navbar.css";

const UpperNavbar = () => {
  return (
    <>
    <nav className="upper-navbar">
        <div className="upper-nav-div">
            <ul>
                <li><NavLink to={"/aboutUs"} className="href">ABOUT US</NavLink></li>
                <li><NavLink to={"/blog"} className="href">BLOG</NavLink></li>
                <li><NavLink to={"/free-dissertation-topic-suggestions"} className="href">TOPIC HELPER</NavLink></li>
                {/* <li><NavLink to={"/faq"} className="href">FAQ</NavLink></li> */}
                <li><a href="tel:+447342141039" className="href">+44 734214 1039</a></li>
                <li><a href="mailto:writemydissertationforme@gmail.com" className="href">writemydissertationforme@gmail.com</a></li>
            </ul>
        </div>
    </nav>
    </>
  )
}

export default UpperNavbar;